module.exports = __webpack_public_path__ + "img/2010 winteressen 029.d3a247be.jpg";